import script from "./UiLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLoader.vue?vue&type=script&setup=true&lang=ts"

import "./UiLoader.vue?vue&type=style&index=0&id=63124e22&lang=css"

const __exports__ = script;

export default __exports__